import { Div, useDragScroll } from '@vgrubs/components';
import { ReactNode } from 'react';
import { AmountsScroller } from './AmountsPanel.styled';

/**
 * One box holding a row of figures that scrolls inside it.
 *
 * The payouts get one and the taxes get another. They used to be loose cards
 * in two strips side by side, which read as a single row that happened to be
 * clipped - people took a tax for one more payout config, and a line drawn
 * between the two halves did not help. A box per group does.
 */
export const AmountsPanel = ({ children }: { children: ReactNode }) => {
  const { ref, onClickCapture, dragScrollStyle } = useDragScroll('x');

  return (
    <Div $box $overflow="hidden">
      <AmountsScroller
        ref={ref}
        onClickCapture={onClickCapture}
        style={dragScrollStyle}
      >
        {children}
      </AmountsScroller>
    </Div>
  );
};
